<template>
  <el-dialog
    :title="$t('deleteAdminServ.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    center
  >
    <div align="center">
      <p>{{ $t('deleteAdminServ.confirmDeleteService') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDeleteAdminServModel">{{ $t('deleteAdminServ.cancel') }}</el-button>
      <el-button type="primary" @click="deleteAdminServ">{{ $t('deleteAdminServ.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteAdminServ } from '@/api/admin/deleteAdminServ/deleteAdminServApi'

export default {
  name: 'DeleteAdminServ',
  data() {
    return {
      dialogVisible: false,
      deleteAdminServInfo: {}
    }
  },
  methods: {
    open(servInfo) {
      this.deleteAdminServInfo = servInfo
      this.dialogVisible = true
    },
    async deleteAdminServ() {
      try {
        const res = await deleteAdminServ(this.deleteAdminServInfo)
        if (res.code === 0) {
          this.$message.success(res.msg)
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('删除服务失败:', error)
        this.$message.error('删除服务失败')
      }
    },
    closeDeleteAdminServModel() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}
</style>